import { useRouter, useSearch } from "@tanstack/react-router";

const parseGroups = (groups: unknown) => {
  return typeof groups === "string"
    ? (JSON.parse(decodeURIComponent(groups)) as string[])
    : Array.isArray(groups)
      ? (groups as string[])
      : undefined;
};

const serializeGroups = (groups: unknown) => {
  return Array.isArray(groups)
    ? encodeURIComponent(JSON.stringify(groups))
    : undefined;
};

export function useDashboardParams() {
  const router = useRouter();
  const {
    page,
    search,
    groups,
    sort,
    per_page,
    month,
    status,
    mentorId,
    last7Days,
  } = useSearch({
    strict: false,
  }) as Record<string, string>;

  const last7DaysBool = last7Days as unknown as boolean;
  const monthNumber = parseInt(month || "0", 10);
  const groupsArray = parseGroups(groups);

  const handleFilterChange = (key: string, value: any) => {
    const encodedGroups = key === "groups" ? serializeGroups(value) : groups;
    router.navigate({
      search: {
        status,
        mentorId,
        search,
        month,
        groups: encodedGroups,
        last7Days: last7DaysBool,
        sort,
        ...(key !== "groups" ? { [key]: value } : {}),
      } as any,
    });
  };

  const handleMultipleFiltersChange = (filters: Record<string, any>) => {
    const encodedGroups =
      "groups" in filters ? serializeGroups(filters.groups) : groups;

    router.navigate({
      search: {
        status,
        mentorId,
        search,
        month,
        last7Days: last7DaysBool,
        sort,
        ...filters,
        groups: encodedGroups,
      } as any,
    });
  };

  const [sortColumn, sortDirection] = sort?.split(".") || [];

  const sortColumnName =
    sortColumn === "mentorship" ? "last_message_date" : sortColumn;

  return {
    page: parseInt(page || "1", 10),
    search,
    groups: groupsArray,
    per_page: parseInt(per_page || "20", 10),
    month: monthNumber,
    status: status || "active",
    mentorId: mentorId || "",
    sortColumn: sortColumnName,
    sortDirection,
    last7Days: last7DaysBool,
    handleFilterChange,
    handleMultipleFiltersChange,
  };
}
